import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-43a6ea4a")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 mb-xl-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body pt-1" }, " Use this report to determine the money's you need to set aside for unbilled periods in the past. ")
], -1)
const _hoisted_2 = { class: "card pt-2" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"row col-md-12\" data-v-43a6ea4a><div class=\"col-md-3\" data-v-43a6ea4a><h6 style=\"color:rgb(46, 49, 146);font-size:medium;\" for=\"FromDate\" data-v-43a6ea4a> From </h6></div><div class=\"col-md-3\" data-v-43a6ea4a><h6 style=\"color:rgb(46, 49, 146);font-size:medium;\" for=\"FromDate\" data-v-43a6ea4a> To </h6></div></div>", 1)
const _hoisted_4 = { class: "row col-md-12" }
const _hoisted_5 = { class: "col-md-3" }
const _hoisted_6 = { class: "col-md-3" }
const _hoisted_7 = { class: "col-md-1" }
const _hoisted_8 = {
  class: "row col-md-12 pt-4",
  style: {"text-align":"center"}
}
const _hoisted_9 = { class: "col-lg-4 col-md-4 col-sm-6 col-xs-12" }
const _hoisted_10 = {
  class: "dashboard-stat dashboard-stat-v2",
  style: {"background-color":"rgb(46, 49, 146)"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "visual" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-shopping-cart fa-3x" })
], -1)
const _hoisted_12 = { class: "details" }
const _hoisted_13 = { class: "number" }
const _hoisted_14 = {
  "data-counter": "counterup",
  id: "lblTotalConsum",
  style: {"color":"white"}
}
const _hoisted_15 = {
  class: "p-3",
  style: {"color":"white","font-size":"30px","font-family":"'Arial'","font-weight":"80"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "desc",
  style: {"color":"white","font-weight":"Normal !important"}
}, " Accural Period ", -1)
const _hoisted_17 = { class: "col-lg-4 col-md-4 col-sm-6 col-xs-12" }
const _hoisted_18 = {
  class: "dashboard-stat dashboard-stat-v2",
  style: {"background-color":"rgb(237, 28, 36)"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "visual" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-shopping-cart fa-3x" })
], -1)
const _hoisted_20 = { class: "details" }
const _hoisted_21 = { class: "number" }
const _hoisted_22 = {
  "data-counter": "counterup",
  id: "lblTotalCost",
  style: {"color":"white"}
}
const _hoisted_23 = {
  class: "p-3",
  style: {"color":"white","font-size":"30px","font-family":"'Arial'","font-weight":"80"}
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  class: "desc",
  style: {"color":"white","font-weight":"Normal"}
}, " Accural Value ", -1)
const _hoisted_25 = { class: "col-lg-4 col-md-4 col-sm-6 col-xs-12" }
const _hoisted_26 = {
  class: "dashboard-stat dashboard-stat-v2",
  style: {"background-color":"rgb(0, 134, 170)"}
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "visual" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chart-bar fa-3x" })
], -1)
const _hoisted_28 = { class: "details" }
const _hoisted_29 = { class: "number" }
const _hoisted_30 = {
  "data-counter": "counterup",
  id: "lblTotalCo2",
  style: {"color":"white"}
}
const _hoisted_31 = {
  class: "p-3",
  style: {"color":"white","font-size":"30px","font-family":"'Arial'","font-weight":"80"}
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", {
  class: "desc",
  style: {"color":"white","font-weight":"normal"}
}, " Accural Days ", -1)
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 1,
  style: {},
  id: "loadingDiv"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, "Loading...", -1)
const _hoisted_36 = [
  _hoisted_35
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_TableTab = _resolveComponent("TableTab")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.fromDate,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.fromDate = $event)),
            type: "date",
            format: "DD/MM/YYYY"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.toDate,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.toDate = $event)),
            type: "date",
            format: "DD/MM/YYYY"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getContent()))
          }, " View ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("a", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, [
                _createElementVNode("h4", _hoisted_15, _toDisplayString(_ctx.accuralperiod), 1)
              ])
            ]),
            _hoisted_16
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("a", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("span", _hoisted_22, [
                _createElementVNode("h4", _hoisted_23, _toDisplayString(_ctx.sumaccuralvalue), 1)
              ])
            ]),
            _hoisted_24
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("a", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("span", _hoisted_30, [
                _createElementVNode("h4", _hoisted_31, _toDisplayString(_ctx.accuraldays), 1)
              ])
            ]),
            _hoisted_32
          ])
        ])
      ])
    ]),
    (_ctx.table)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createVNode(_component_TableTab, {
            key: _ctx.tableValues.length,
            "table-data": _ctx.tableValues,
            "table-header": _ctx.OriginalTableHeaders,
            "enable-items-per-page-dropdown": true,
            selectedType: _ctx.colnames,
            pagetitle: _ctx.pageheader,
            downloadUrl: _ctx.downloadurl,
            downloadprops: _ctx.downloadprops,
            isTemplateDownload: true
          }, _createSlots({ _: 2 }, [
            _renderList(_ctx.colnames, (slot) => {
              return {
                name: `cell-${slot}`,
                fn: _withCtx(({ row: customer }) => [
                  _createTextVNode(_toDisplayString(customer[slot]), 1)
                ])
              }
            })
          ]), 1032, ["table-data", "table-header", "selectedType", "pagetitle", "downloadUrl", "downloadprops"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
      : _createCommentVNode("", true)
  ], 64))
}